export enum StorageSelectShippingActionTypes {
  STORAGE_SET_CARRIER_TYPE = "STORAGE_SET_CARRIER_TYPE",
  STORAGE_SET_PALLET_CONFIGURATIONS = "STORAGE_SET_PALLET_CONFIGURATIONS",
  STORAGE_SET_FREIGHT_ORDER_DETAILS = "STORAGE_SET_FREIGHT_ORDER_DETAILS",
  STORAGE_SET_SELECTED_QUOTE_DETAILS = "STORAGE_SET_SELECTED_QUOTE_DETAILS",
  RESET_STORAGE_SELECTED_QUOTE_DETAILS = "RESET_STORAGE_SELECTED_QUOTE_DETAILS",
  STORAGE_SET_TOTAL_CARGO_WEIGHT = "STORAGE_SET_TOTAL_CARGO_WEIGHT",
}
